export const sortListByLabel = (list: {
    value: string;
    label: string;
}[]) => {
    return list.sort(function compare(a, b) {
        if (a.label < b.label) {
            return -1;
        }
        if (a.label > b.label) {
            return 1;
        }
        return 0;
    })
}

export enum VerificationType {
    PHONE = 'PHONE',
    EMAIL = 'EMAIL',
    PIN = 'PIN'
}